import { initialState } from "./initialState";
import { Actions, ActionTypes, Page, State } from "./types";

export const updateEmailReducer = (state: State, action: Actions): State => {
  switch (action.type) {
    case ActionTypes.BACK: {
      return initialState;
    }
    case ActionTypes.ERROR: {
      return { status: Page.ERROR };
    }
    case ActionTypes.OTP_NEEDED: {
      const { email, createSessionUrl, token } = action;
      return {
        status: Page.OTP_REQUIRED,
        email,
        createSessionUrl,
        token,
      };
    }
    case ActionTypes.SUCCESS: {
      return { status: Page.SUCCESS, email: action.email };
    }
    case ActionTypes.VERIFY: {
      return { status: Page.VERIFY_EMAIL, verifyUrl: action.verifyUrl };
    }
    case ActionTypes.OTP_SUCCESS: {
      return { status: Page.INITIAL };
    }
    default: {
      return state;
    }
  }
};
